<template>
  <v-row dense justify="center">
    <template v-if="events && events.length">
      <v-col cols="12" class="title d-flex align-center">
        <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Eventos Disponíveis
      </v-col>
      <v-col cols="12" v-for="event in events" :key="`event-${event.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text">
            <v-icon color="secondary" left>mdi-clipboard-text</v-icon> {{ event.name }}
          </v-card-subtitle>
          <v-card-text class="pb-0">
            Total de Vagas: {{ event.total_places }}, Restantes: {{ event.total_places_remaining }}
          </v-card-text>
          <v-card-text class="pt-0">
            <v-chip outlined v-for="group in event.groups" :key="`group-${group.id}`" class="mr-2 mt-2">
              {{ group.name }}
            </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn block color="secondary" text :to="{ name: 'ambienteAluno.events' }">Todos os Eventos</v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn block color="secondary" text :to="{ name: 'ambienteAluno.eventSessions' }">Minhas Sessões Agendadas</v-btn>
      </v-col>
    </template>
    <template v-if="groups && groups.length">
      <v-col cols="12" class="title d-flex align-center">
        <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Murais
      </v-col>
      <v-col cols="12" md="6" v-for="group in groups" :key="`group-${group.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text">
            <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Mural: {{ group.syllabus.course.name }} » {{ group.name }}
          </v-card-subtitle>
          <v-card-text class="annotation">
            <div v-html="group.annotations"/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn block color="secondary" text :to="{ name: 'ambienteAluno.annotations' }">Ver Todos</v-btn>
      </v-col>
    </template>
    <v-col cols="12">
      <v-card outlined flat class="fill-height">
        <v-card-title>
          <v-icon color="secondary" left>mdi-book</v-icon> Aulas concluídas
        </v-card-title>
        <v-card-text>
          <div class="g-chart-dashboard">
            <GChart
              style="margin: 0 auto; width: 935px; overflow-y: hidden;"
              :settings="{ packages: ['corechart', 'calendar'], language: 'pt'}"
              type="Calendar"
              :data="chartData"
              :options="chartOptions"
              :resizeDebounce="0"/>
          </div>
          <small class="text-center d-block">O gráfico acima mostra a quantidade de aulas concluídas por dia.</small>
          <small class="text-center d-block">Os dias com cores mais escuras significam mais aulas concluídas.</small>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card outlined flat class="fill-height">
        <v-card-title>
          <v-icon color="secondary" left>mdi-book-open-variant</v-icon> Continuar estudando
        </v-card-title>
        <v-card-text>
          <strong>{{dashboardItems.lastLesson.lesson}}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text :to="{ name: 'salaDeAula', params: { matriculaId: dashboardItems.lastLesson.enrollmentId } }">
            Sala de Aula
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card outlined flat class="fill-height">
        <v-card-title>
          <v-icon color="secondary" left>mdi-chat</v-icon> Fóruns
        </v-card-title>
        <v-card-text>
          <strong>Ir para a área de fóruns</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text :to="{ name: 'ambienteAluno.forum.index' }">
            Acessar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
import { SalaDeAula, Course, Event } from '@/services/resources'

export default {
  components: {
    GChart
  },
  name: 'Dashboard',
  data () {
    return {
      groups: null,
      eventSessions: null,
      events: null,
      chartOptions: {
        height: 200,
        width: 912
      },
      chartData: [
        ['Date', 'Lessons']
      ],
      dashboardItems: {
        lastLesson: {
          enrollmentId: 0,
          lesson: 'Aula'
        }
      }
    }
  },
  mounted () {
    if (!this.user) {
      store.dispatch('App/getUser')
    }
    Course.groups(2)
      .then(response => {
        this.groups = response.data.groups
      }).catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })
    Event.events(1)
      .then(response => {
        this.events = response.data.events
      }).catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })
    Course.getStudentLessonDays()
      .then((response) => {
        const dates = []
        Object.keys(response.body.lessonProgresses).forEach((key) => {
          dates.push([new Date(response.body.lessonProgresses[key].date + 'T03:00:00'), response.body.lessonProgresses[key].count])
        })
        this.chartData = this.chartData.concat(dates)

        if (this.chartData.length === 1) {
          this.chartData.push([new Date(), 0])
        }
      })
      .catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })

    SalaDeAula.getLastLessonData()
      .then((response) => {
        this.dashboardItems.lastLesson.enrollmentId = response.body.return.lessonData.enrollment_id
        this.dashboardItems.lastLesson.lesson = response.body.return.lessonData.lesson
      })
      .catch((error) => {
        console.log('responseError', error)
        if (typeof error.body.return.message !== 'undefined') {
          this.$toasted.global.error({ message: error.body.return.message })
        } else {
          this.$toasted.global.error({ message: error.statusText })
        }
      })
  },
  computed: {
    ...mapGetters({
      user: 'App/user',
      enrollmentId: 'SalaDeAula/enrollmentId'
    })
  }
}
</script>

<style lang="scss">
  .g-chart-dashboard {
    display: flex;
    justify-content: center;
    align-content: center;
    overflow-x: auto;

    svg {
      margin: 0 auto;
    }
  }

  .control-dashboard {
    display: flex;
    flex-wrap: wrap;
  }

  .card-dashboard-items {
     .card__media__content {
        justify-content: center;
     }
  }

  .annotation img {
    max-width: 100% !important;
  }
</style>
